import { 
    SET_SCHEDULED_LIST, 
    SET_SCHEDULER, 
    SET_SCHEDULED_LIST_DATERANGE,
    SET_RESET_SCHEDULE_LIST,
    SET_LOADING_API
} from './actions';

export const initialState = {
    schedule: {},
    scheduledList: {
      result: [],
      nextToken: ""
    },
    scheduleListDateRange: {},
    loading: false,
}

export const scheduler = 
    (state = initialState, action: any) => {
    switch (action.type) {
      case SET_SCHEDULER:
        return { ...state, schedule: action.payload || {}, loading: false };
      case SET_SCHEDULED_LIST:
        let packageList : any = state.scheduledList;
        if(action.payload?.result && action.payload?.nextToken) {
          packageList.result = [...packageList.result, ...action.payload.result];
          packageList.nextToken = action.payload.nextToken;
        }
        return { ...state, scheduledList: packageList || {}, loading: false };
      case SET_SCHEDULED_LIST_DATERANGE:
        return { 
            ...state, 
            scheduleListDateRange: action.payload || {},
            loading: false
        }
      case SET_RESET_SCHEDULE_LIST:
        return { 
          ...state, 
          scheduledList: {
            result: [],
            nextToken: ""
          },
          scheduleListDateRange: {}
        };
      case SET_LOADING_API: 
        return { ...state, loading: action.payload || false}
      default:
        return state;
    }
}